import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/singleBetGameCard.css';
// constants
import {PLACE, SHOW, TO_WIN} from '../constants/identifiers';
import {ASSETS_URL} from '../../../../../constants/endpoints';
// helpers
import {getOddsFromOddsType} from '../../../../../helpers/oddsHelpers';
import {hasEventTypeRacerNumberUI, isMarbleEuroEvent, isMarbleNonEuroEvent} from '../helpers/racersHelper';

//actions
import {getGameFromChannel} from "../../../helpers/gameHelpers";
import SingleButton from "./singleButton"
import {isEnabledMarket} from "../../../helpers/betHelpers";
import {getText} from '../../../../../helpers/localization';

const mapStateToProps = (state, ownProps) => {
    return {
        games: state.vpp.games,
        events: state.vpp.events,
        selectedGameIndex: state.vpp.selectedGameIndex,
        selectedEventIndex: state.vpp.selectedEventIndex,
        openBetsList: state.vpp.openBetsList,
        selectedOddsType: state.vpp.selectedOddsType,
        systemLanguage: state.vpp.systemLanguage,
        disabledMarkets: state.vpp.disabledMarkets
    };
};

class SingleBetGameCard extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            games: storeData.vpp.games,
            events: storeData.vpp.events,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            openBetsList: storeData.vpp.openBetsList,
            selectedOddsType: storeData.vpp.selectedOddsType,
            systemLanguage: storeData.vpp.systemLanguage,
            disabledMarkets: storeData.vpp.disabledMarkets
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState(
                {
                    games: storeData.vpp.games,
                    events: storeData.vpp.events,
                    selectedEventIndex: storeData.vpp.selectedEventIndex,
                    openBetsList: storeData.vpp.openBetsList,
                    selectedOddsType: storeData.vpp.selectedOddsType,
                    systemLanguage: storeData.vpp.systemLanguage,
                    selectedGameIndex: storeData.vpp.selectedGameIndex,
                    disabledMarkets: storeData.vpp.disabledMarkets
                }
            );
        }
    }

    render() {

        let racerIcon;
        let store = this.props.store;
        let storeData = store.getState();
        let eventType = this.state.events[this.state.selectedEventIndex].eventType;
        let channel = this.state.games[this.state.selectedGameIndex].channel;
        let gameName = this.state.games[this.state.selectedGameIndex].name;

        if (this.state.events && this.state.events.length && this.state.games && this.state.games.length
            && this.state.games[this.state.selectedGameIndex].channel === this.state.events[this.state.selectedEventIndex].channel) {
            let racerImage;
            if (isMarbleEuroEvent(eventType, gameName))
                racerImage = `${ASSETS_URL}${getGameFromChannel(this.state.events[this.state.selectedEventIndex].channel, storeData.vpp.games).assetsPath}/silks/marbles/silk${Number(this.props.racer.silk) + 1}.png`;
            else
                racerImage = `${ASSETS_URL}${getGameFromChannel(this.state.events[this.state.selectedEventIndex].channel, storeData.vpp.games).assetsPath}/silks/silk${Number(this.props.racer.silk) + 1}.png`;

            racerIcon = (<div id={'racer_silk_' + this.props.racer.num} className={style.racerIcon}>
                    <img
                        src={racerImage}
                        className={style.racerIconImage}
                        alt={`icon${this.props.racer.silk}`}/></div>
            );
        }
        let isLastStyle = this.props.isLast
            ? style.last
            : '';
        let racerNumberStyle = hasEventTypeRacerNumberUI(eventType) ? isMarbleNonEuroEvent(eventType, gameName) ? `${style.racerNumber} ${style.marbleFont}` : style.racerNumber : '';
        let racerName = isMarbleEuroEvent(eventType, gameName) ? getText(gameName + "_" + this.props.racer.num, this.props.store) : this.props.racer.name.toLowerCase();

        let toWinContainer;
        let placeContainer;
        let showContainer;
        if (isEnabledMarket(this.state, this.props.disabledMarkets, channel, TO_WIN.name) && this.props.racer.oddsFirst != undefined) {
            let toWinOdd = getOddsFromOddsType(this.props.racer.oddsFirst, this.state.selectedOddsType);
            toWinContainer = (<div>
                <SingleButton racer={this.props.racer} store={this.props.store} buttonStyle={style.buttonCustomStyle}
                              marketId={TO_WIN.code + '-' + this.props.marketNum} marketNum={this.props.marketNum}
                              odd={toWinOdd} betType={TO_WIN} circleSize={'medium'}></SingleButton>
            </div>)
        }

        if (isEnabledMarket(this.state, this.props.disabledMarkets, channel, PLACE.name) && this.props.racer.oddsPlace != undefined) {
            let placeOdd = getOddsFromOddsType(this.props.racer.oddsPlace, this.state.selectedOddsType);
            placeContainer = (<div>
                <SingleButton racer={this.props.racer} store={this.props.store} buttonStyle={style.buttonCustomStyle}
                              marketId={PLACE.code + '-' + this.props.marketNum} marketNum={this.props.marketNum}
                              odd={placeOdd} betType={PLACE} circleSize={'medium'}></SingleButton>
            </div>);
        }

        if (isEnabledMarket(this.state, this.props.disabledMarkets, channel, SHOW.name) && this.props.racer.oddsShow != undefined) {
            let showOdd = getOddsFromOddsType(this.props.racer.oddsShow, this.state.selectedOddsType);
            showContainer = (<div>
                <SingleButton racer={this.props.racer} store={this.props.store} buttonStyle={style.buttonCustomStyle}
                              marketId={SHOW.code + '-' + this.props.marketNum} marketNum={this.props.marketNum}
                              odd={showOdd} betType={SHOW} circleSize={'medium'}></SingleButton>
            </div>);
        }

        return (
            <div id={'racer_' + this.props.racer.num} className={`${style.singleBetGameCardContainer} ${isLastStyle}`}>
                {racerIcon}
                <div
                    className={`${racerNumberStyle}`}>{hasEventTypeRacerNumberUI(eventType) ? this.props.racer.num : ''}</div>
                <div id={'racer_name_' + this.props.racer.num} className={style.racerName}>{racerName}</div>
                {toWinContainer}
                {placeContainer}
                {showContainer}
            </div>
        );
    }
}

export default connect(mapStateToProps)(SingleBetGameCard);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/components/singleBetGameCard.js